export const responsiveFontSizes = ({ sm, md, lg }) => ({
  '@media (min-width:600px)': {
    fontSize: `${sm}rem`
  },
  '@media (min-width:900px)': {
    fontSize: `${md}rem`
  },
  '@media (min-width:1200px)': {
    fontSize: `${lg}rem`
  }
})

const minimalTypography = {
  fontFamily: 'Roboto, sans-serif',
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontWeight: 800,
    lineHeight: 1.25,
    fontSize: `${2.5}rem`,
    ...responsiveFontSizes({ sm: 3.25, md: 3.625, lg: 4 })
  },
  h2: {
    fontWeight: 800,
    lineHeight: 1.3,
    fontSize: `${2}rem`,
    ...responsiveFontSizes({ sm: 2.5, md: 2.75, lg: 3 })
  },
  h3: {
    fontWeight: "bold",
    lineHeight: 1.5,
    fontSize: `${1.5}rem`,
    ...responsiveFontSizes({ sm: 1.625, md: 1.875, lg: 2 })
  },
  h4: {
    fontWeight: "bold",
    lineHeight: 1.5,
    fontSize: `${1.5}rem`,
    ...responsiveFontSizes({ sm: 1.25, md: 1.5, lg: 1.5 })
  },
  h5: {
    fontWeight: "bold",
    lineHeight: 1.5,
    fontSize: `${1.125}rem`,
    ...responsiveFontSizes({ sm: 1.1875, md: 1.25, lg: 1.25 })
  },
  h6: {
    fontWeight: "bold",
    lineHeight: 1.55,
    fontSize: `${1.0625}rem`,
    ...responsiveFontSizes({ sm: 1.125, md: 1.125, lg: 1.125 })
  },
  subtitle1: {
    fontWeight: "medium",
    lineHeight: 1.5,
    fontSize: `${1}rem`
  },
  subtitle2: {
    fontWeight: "medium",
    lineHeight: 1.57,
    fontSize: `${0.875}rem`
  },
  body1: {
    lineHeight: 1.5,
    fontSize: `${1}rem`
  },
  body2: {
    lineHeight: 1.57,
    fontSize: `${0.875}rem`
  },
  caption: {
    lineHeight: 1.5,
    fontSize: `${0.75}rem`
  },
  overline: {
    fontWeight: "bold",
    lineHeight: 1.5,
    fontSize: `${0.75}rem`,
    textTransform: 'uppercase'
  },
  button: {
    fontWeight: "bold",
    lineHeight: 1.7,
    fontSize: `${0.875}rem`,
    textTransform: 'capitalize'
  },
};

export default minimalTypography;
